<script>
import EditorJS from '@editorjs/editorjs';
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Image from "@editorjs/image";

export default {
    name: "DocumentEdit",
    data() {
        return {
            editor: null
        }
    },
    mounted() {
        this.editor = new EditorJS({
            holder: 'editorjs',
            data: {
                blocks: [
                    {
                        type: "paragraph",
                        data: {
                            text: "Hello World!"
                        }
                    }
                ]
            },
            tools: {
                header: {
                    class: Header, // 使用的工具类
                    inlineToolbar: true, // 启用内联工具栏
                },
                list: {
                    class: List,
                    inlineToolbar: true,
                },
                image: {
                    class: Image,
                    config: {
                        uploader: {
                            uploadByFile(file) {
                                // 上传图片的逻辑
                                return new Promise((resolve, reject) => {
                                    // 模拟上传
                                    resolve({ success: 1, file: { url: 'https://example.com/image.jpg' } });
                                });
                            }
                        }
                    }
                }
            },
        });
    }
}
</script>

<template>
    <main-layout>
        <section class="page-section">
            <div id="editorjs"></div>
        </section>
    </main-layout>
</template>

<style scoped>

</style>